import { render, staticRenderFns } from "./CompanyAdmin.vue?vue&type=template&id=0a89d24c"
import script from "./CompanyAdmin.vue?vue&type=script&lang=js"
export * from "./CompanyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a89d24c')) {
      api.createRecord('0a89d24c', component.options)
    } else {
      api.reload('0a89d24c', component.options)
    }
    module.hot.accept("./CompanyAdmin.vue?vue&type=template&id=0a89d24c", function () {
      api.rerender('0a89d24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/CompanyAdmin.vue"
export default component.exports